<div *ngIf="currentUser">
  <div class="mb-1 page-padding-x ">
    <app-banner *ngIf="maintenanceMessage" id="dashboard-banner" [bannerIcon]="materialSymbols.info" [message]="maintenanceMessage"></app-banner>
    <h1 class="page-padding-y" id="h-dashboard-page">Welcome back {{ currentUser.firstName }}</h1>
  </div>

  <div class="space-y-12">
    <div *ngIf="isCurrentUserCM" class="py-12 dashboard-section-grey">
      <app-project-updates></app-project-updates>
    </div>

    <div *ngIf="isCurrentUserCM" class="py-12">
      <app-committee-updates></app-committee-updates>
    </div>

    <div class="py-12 dashboard-section-grey">
      <app-news></app-news>
    </div>

  </div>

  <div class="page-padding-x">
    <app-connect-links id="connect-links-section"></app-connect-links>
  </div>
  <hr />
  <br />
</div>
